import { Route } from "react-router";
import PatientSharedEducationalMaterialsRedirect from "@/packages/patientSharedContent/components/PatientSharedEducationalMaterialsRedirect";
import { EducationalMaterialsTabs } from "@Core/patientShared/PatientShared.types";
import {
  APPOINTMENTS_VIEW,
  CLIENT,
  CLIENT_PROGRAMS_NEW,
  ENERGY_BALANCE_VIEW,
  HEALTH_AND_GOALS_VIEW,
  INFO_AND_SERVICES_VIEW,
  PATIENT_AI_NOTES,
  PATIENT_FILES,
  PATIENT_MONITORING,
  PATIENT_MONITORING_CUSTOM,
  PATIENT_MONITORING_DAY,
  PATIENT_MONITORING_MONTH,
  PATIENT_MONITORING_WEEK,
  PATIENT_PROGRAM,
  PATIENT_SHARED,
  PATIENT_SHARED_COLLECTIONS,
  PATIENT_SHARED_DIETS,
  PATIENT_SHARED_EDUCATIONAL_MATERIALS,
  PATIENT_SHARED_EDUCATIONAL_MATERIALS_PDF,
  PATIENT_SHARED_EDUCATIONAL_MATERIALS_TEXT,
  PATIENT_SHARED_EDUCATIONAL_MATERIALS_VIDEO,
  PATIENT_SHARED_RECIPES,
  QUESTIONNAIRE_ANSWERS,
} from "@routes/routes";
import {
  AiNotesPage,
  ClientHealthNewPage,
  ClientProfilePage,
  PatientBalancePage,
  PatientMonitoringNewPage,
  PatientProgramPage,
  PatientProgramsPage,
  PatientSharedCollectionsPage,
  PatientSharedDietsPage,
  PatientSharedEducationalMaterialsPage,
  PatientSharedPage,
  PatientSharedRecipesPage,
  PatientFilesPage,
  PatientVisitsPage,
  ClientPage,
  ClientProgramHeaderLayout,
  PatientSurveyAnswerPage,
} from "@routes/lazyPages";

/** Everything under a single client (/patients/:id/*). */
export const clientRoutes = (
  <>
    <Route path={CLIENT} lazy={ClientPage}>
      <Route path={HEALTH_AND_GOALS_VIEW} lazy={ClientHealthNewPage} />
      <Route path={INFO_AND_SERVICES_VIEW} lazy={ClientProfilePage} />
      <Route path={APPOINTMENTS_VIEW} lazy={PatientVisitsPage} />
      <Route path={PATIENT_AI_NOTES} lazy={AiNotesPage} />
      <Route path={PATIENT_FILES} lazy={PatientFilesPage} />
      <Route path={ENERGY_BALANCE_VIEW} lazy={PatientBalancePage} />
      <Route path={CLIENT_PROGRAMS_NEW} lazy={PatientProgramsPage} />
      <Route path={PATIENT_MONITORING} lazy={PatientMonitoringNewPage} />
      <Route path={PATIENT_MONITORING_DAY} lazy={PatientMonitoringNewPage} />
      <Route path={PATIENT_MONITORING_WEEK} lazy={PatientMonitoringNewPage} />
      <Route path={PATIENT_MONITORING_MONTH} lazy={PatientMonitoringNewPage} />
      <Route path={PATIENT_MONITORING_CUSTOM} lazy={PatientMonitoringNewPage} />
      <Route path={QUESTIONNAIRE_ANSWERS} lazy={PatientSurveyAnswerPage} />
      <Route lazy={ClientProgramHeaderLayout}>
        <Route path={PATIENT_PROGRAM} lazy={PatientProgramPage} />
      </Route>
      <Route path={PATIENT_SHARED} lazy={PatientSharedPage} />
      <Route
        path={PATIENT_SHARED_COLLECTIONS}
        lazy={PatientSharedCollectionsPage}
      />
      <Route path={PATIENT_SHARED_DIETS} lazy={PatientSharedDietsPage} />
      <Route path={PATIENT_SHARED_RECIPES} lazy={PatientSharedRecipesPage} />
      <Route
        path={PATIENT_SHARED_EDUCATIONAL_MATERIALS}
        lazy={PatientSharedEducationalMaterialsPage}
      />
      <Route
        path={PATIENT_SHARED_EDUCATIONAL_MATERIALS_TEXT}
        element={
          <PatientSharedEducationalMaterialsRedirect
            tab={EducationalMaterialsTabs.TEXT_MATERIALS}
          />
        }
      />
      <Route
        path={PATIENT_SHARED_EDUCATIONAL_MATERIALS_VIDEO}
        element={
          <PatientSharedEducationalMaterialsRedirect
            tab={EducationalMaterialsTabs.VIDEO_FILES}
          />
        }
      />
      <Route
        path={PATIENT_SHARED_EDUCATIONAL_MATERIALS_PDF}
        element={
          <PatientSharedEducationalMaterialsRedirect
            tab={EducationalMaterialsTabs.PDF_FILES}
          />
        }
      />
    </Route>
  </>
);
